module.exports = __webpack_public_path__ + "img/location-icon.eb894d74.svg";